<mat-dialog-content class="mat-typography">
    <div class="container" style="padding-top: 15px;">
        <form [formGroup]="data.form">
            <ng-container [ngSwitch]="data.key">
                <ng-container *ngSwitchCase="'name'">
                    <mat-form-field appearance="standard" class="full_width_form">
                        <mat-label>{{ "Card title" | translate }}</mat-label>
                        <mat-select [disableOptionCentering]="true" selectDir formControlName="name">
                            <mat-option [value]="'{video_name}'">
                                {{ "Video title" | translate }}
                            </mat-option>
                            <mat-option [value]="'{video_filename}'">
                                {{ "File name" | translate }}
                            </mat-option>
                            <mat-option [value]="'{video_name} {video_filename}'">
                                {{ "Video title + file name" | translate }}
                            </mat-option>
                            <mat-option [value]="'{video_filename} {video_name}'">
                                {{ "File name + video title" | translate }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </ng-container>
                <ng-container *ngSwitchCase="'status_id'">
                    <mat-form-field appearance="standard" class="full_width_form">
                        <mat-label>{{ "Type" | translate }}</mat-label>
                        <mat-select [disableOptionCentering]="true" selectDir formControlName="status_id">
                            <mat-option>
                                <ngx-mat-select-search 
                                placeholderLabel="{{ 'Search' | translate }}" 
                                noEntriesFoundLabel="{{ 'no matching type found' | translate }}"
                                [formControl]="statusesMoreControl"></ngx-mat-select-search>
                            </mat-option>
                            <mat-option *ngFor="let status of statuses$ | async" [value]="status.id">
                                {{ status.name | translate }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </ng-container>
                <ng-container *ngSwitchCase="'priority'">
                    <mat-form-field appearance="legacy" class="filter_form priority">
                        <mat-label>{{ "Priority" | translate }}</mat-label>
                        <mat-select [disableOptionCentering]="true" selectDir formControlName="priority">
                            <mat-option *ngFor="let priority of data.prioritys" [value]="priority.id">
                                {{ priority.name | translate }}
                            </mat-option>
                        </mat-select>
                      </mat-form-field>
                </ng-container>
            </ng-container>
        </form>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button (click)="close()">
        {{ "Close" | translate }}
    </button>
</mat-dialog-actions>